import { useRequest } from "../../../hooks/useRequest";
import useHttpResponseAlert from "../../../hooks/useHttpResponseAlert";
import routes from "../../../routes";

function useStripeLink(userId: string) {
  const { fetch, response, error, loading } = useRequest();

  const { alert, setAlert } = useHttpResponseAlert(
    error,
    response,
    "User successfully linked to Stripe!",
  );

  const link = () => {
    fetch("PUT", routes.api.user.stripeLink({ userId }));
  };

  return {
    link,
    loading,
    url: response?.data.stripeUrl,
    alert,
    setAlert,
  };
}

export default useStripeLink;
